import { supabase } from "./supabase";

export async function fetchPublishedArticles() {
  const { data, error } = await supabase
    .from("articles")
    .select("*")
    .eq("published", true)
    .order("created_at", { ascending: false });

  if (error) {
    console.error("❌ Error fetching articles:", error.message);
    return [];
  }

  return data;
}

export async function fetchArticleBySlug(slug: string) {
  const { data, error } = await supabase
    .from('articles')
    .select('*')
    .eq('slug', slug)
    .single();

  if (error) {
    console.error("Error fetching article:", error);
    return null;
  }

  return data;
}

export async function updateArticleById(id: string, data: Partial<Article>) {
  try {
    // First update the article
    const { error: updateError } = await supabase
      .from("articles")
      .update({
        ...data,
        updated_at: new Date().toISOString()
      })
      .eq("id", id);

    if (updateError) {
      throw updateError;
    }

    // Then fetch the updated article to confirm changes
    const { data: updatedArticle, error: fetchError } = await supabase
      .from("articles")
      .select("*")
      .eq("id", id)
      .single();

    if (fetchError) {
      throw fetchError;
    }

    if (!updatedArticle) {
      throw new Error("Failed to fetch updated article");
    }

    return updatedArticle;
  } catch (error) {
    console.error("Error updating article:", error);
    throw error;
  }
}

export async function fetchFeaturedArticles() {
  const { data, error } = await supabase
    .from('articles')
    .select('*')
    .eq('published', true)
    .order('published_date', { ascending: false })
    .limit(3);

  if (error) {
    console.error("Error fetching featured articles:", error);
    return [];
  }

  return data;
}

export async function fetchArticlesByCategory(category: string) {
  const { data, error } = await supabase
    .from('articles')
    .select('*')
    .eq('published', true)
    .eq('category', category)
    .order('published_date', { ascending: false });

  if (error) {
    console.error("Error fetching articles by category:", error);
    return [];
  }

  return data;
}

interface Article {
  id: string;
  title: string;
  content: string;
  excerpt?: string;
  image_url?: string;
  published: boolean;
  published_date?: string;
  author?: string;
  slug?: string;
  category?: string;
}